const PARTNERS = [
  {
    name: "Niger State Government",
    role: "Host State Government",
    body: "Official host state of the Agrovest Reality TV Show, providing the Farm Hub venue, security, infrastructure support, and high-level policy backing under the leadership of His Excellency Governor Mohammed Umar Bago.",
    color: "#2BA84A",
    logo: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/lzz96qxh_image.png",
  },
  {
    name: "Niger State Ministry of Agriculture",
    role: "Government Pioneer State Partner",
    body: "Farm Hub land provision, policy support, press briefings, Governor Bago naming honour, and co-branding across all episodes.",
    color: "#F26A1F",
    logo: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/4qsld5lh_WhatsApp%20Image%202026-05-30%20at%2012.30.08%20AM.jpeg",
  },
  {
    name: "Sydani Group",
    role: "Strategic Corporate Partner",
    body: "Strategic investment and co-production partnership. Agribusiness advisory and access to a network of agricultural investors and market players.",
    color: "#2BA84A",
    logo: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/n568u5gk_image.png",
  },
  {
    name: "Olohi Integrated Farms Limited",
    role: "Agricultural Partner",
    body: "On-ground agric expertise and production support. Farm Hub operational management and contestant training in livestock and crop production.",
    color: "#F26A1F",
    logo: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/frtrqyxa_WhatsApp%20Image%202026-05-30%20at%2012.27.32%20AM.jpeg",
  },
  {
    name: "National Orientation Agency (NOA)",
    role: "Media & Outreach Partner",
    body: "National grassroots mobilisation for auditions and registration. Co-branding in NOA communications and community outreach across all 36 states + FCT.",
    color: "#2BA84A",
    logo: "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/8r20isjs_image.png",
  },
];

export default function Sponsors() {
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-12 py-24">
      <div className="text-xs uppercase tracking-[0.3em] text-[#F26A1F] mb-5">
        Power the revolution
      </div>
      <h1
        className="text-5xl md:text-7xl font-black tracking-tighter leading-[0.95] mb-6"
        style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
      >
        Partner with <span className="text-[#F26A1F]">ARTS</span>.<br />
        Be seen by <span className="text-[#2BA84A]">10 million+</span> Nigerians every week.
      </h1>
      <p className="text-white/70 max-w-2xl leading-relaxed">
        Agrovest Season 1 is proudly supported by the following pioneer
        partners. We invite forward-thinking organisations to power the
        future of African agriculture with us.
      </p>

      <div className="mt-16 grid md:grid-cols-2 gap-4">
        {PARTNERS.map((p) => (
          <div
            key={p.name}
            className="p-8 border border-white/10 hover:border-white/30 transition-colors bg-black flex flex-col"
          >
            <div className="flex items-start justify-between gap-4 mb-5">
              <div
                className="text-xs uppercase tracking-[0.3em] font-bold"
                style={{ color: p.color }}
              >
                {p.role}
              </div>
              <div className="h-16 w-16 shrink-0 bg-white p-1.5 rounded-sm flex items-center justify-center">
                <img
                  src={p.logo}
                  alt={p.name}
                  loading="lazy"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            </div>
            <h3
              className="text-2xl font-bold tracking-tight mb-3"
              style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
            >
              {p.name}
            </h3>
            <p className="text-sm text-white/60 leading-relaxed">{p.body}</p>
          </div>
        ))}
      </div>

      <section className="mt-20 p-10 border border-[#F26A1F]/40 bg-[#F26A1F]/5 text-center">
        <div className="text-xs uppercase tracking-[0.3em] text-[#F26A1F] mb-3">
          Become a partner
        </div>
        <h3
          className="text-3xl md:text-4xl font-bold tracking-tighter mb-4"
          style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
        >
          Sponsor a season. Shape a generation.
        </h3>
        <a
          href="mailto:sponsors@agrovesttvshow.com.ng"
          className="h-12 px-8 inline-flex items-center gap-2 rounded-sm bg-[#F26A1F] hover:bg-[#D95A15] text-white text-xs uppercase tracking-[0.2em] font-bold mt-4"
        >
          sponsors@agrovesttvshow.com.ng
        </a>
      </section>
    </div>
  );
}
